import { mergeMatches } from '@utils/match';

export default (state = [], action = {}) => {
  switch (action.type) {
    case 'MATCHES_SET':
      return action.payload;
    case 'MATCHES_MERGE':
      return mergeMatches(action.payload, state);
    case 'MATCHES_MATCH_SET': {
      return state.map(
        match =>
          match.mid === action.meta.mid
            ? { ...match, ...action.payload }
            : match
      );
    }
    default:
      return state;
  }
};
